//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "./components/header/hearer";
import Menu from "./components/menu/menu";
import SysContentHeader from "./components/sys-content-header/sys-content-header";
import { mapState, mapMutations } from "vuex";
import i18n from './config/i18n';
export default {
  name: "app",
  data() {
    return {
      menuId: "",
      isCollapse: false,
      isHome: false,
      footerBg: false
    };
  },
  methods: {
    thatUrl(to) {
      if (to) {
        this.footerBg = to.meta.footerBg || false;
        if (to.matched[0]) {
          const name = to.matched[0].components.default.name;
          let englishName = '';
          if(to.meta.nameKey){
            englishName = i18n.t('childMenuTitle.'+to.meta.nameKey)
          }else{
            englishName = to.meta && to.meta.menuData ? to.meta.menuData.englishName : ""
          }
          const routerTag = {
            url: to.path,
            name: to.name,
            componentsName: name,
            fullPath: to.fullPath,
            mainIdex: to.meta && to.meta.mainPage ? true : false,
            englishName:englishName
          };
          this.SET_TODATE(to);
          if (routerTag.url !== "/login" && routerTag.url !== "/blank-page") {
            this.SET_GOROUTER(routerTag);
          }
        }
        if (to.path.indexOf("/home") != -1 || to.path == "/") {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
        if (to.meta.menuData) {
          this.menuId = to.meta.menuData.menuIndex;
        }
        const data = to.meta;
        data.fullPath = to.fullPath;
        data.name = to.name;
        this.SET_TODATE(to.meta);
      }
    },
    ...mapMutations(["SET_GOROUTER", "SET_TODATE"]),
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "thatUrl",
  },
  created() {
    if (!this.$config.languageShow) {
      sessionStorage.setItem("language", "zh-CN");
    }
    if (this.$config.defaultOprTitle) {
      document.title = this.$config.defaultOprTitle;
    }
  },
  mounted() {
    this.thatUrl(this.$route);
  },
  components: {
    "pi-header": Header,
    "pi-menu": Menu,
    "sys-content-header": SysContentHeader,
    // "pi-div-scroll": divScroll
  },
  computed: {
    ...mapState(["sys"]),
  },
};
